import { Injectable } from '@angular/core';
import { RestService } from '../_rest.service';

@Injectable({
  providedIn: 'root'
})
export class ForumEvenementPartService extends RestService{

  init(){
    this.endpoint = 'evenementparts';
    this.modelname = 'evenementpart';
    }
}
